import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/editor';

const TextEditor = forwardRef(({
    initialValue = '',
    height = '500px',
    onChange,
    readOnly = false,
}, ref) => {
    const editorRef = useRef(null);
    const editorInstanceRef = useRef(null);

    useEffect(() => {
        editorInstanceRef.current = new Editor({
            el: editorRef.current,
            initialEditType: 'wysiwyg',
            previewStyle: 'vertical',
            height: height,
            initialValue: initialValue,
            toolbarItems: readOnly ? [] : [
                ['bold', 'italic', 'strike'],
                ['heading', 'quote'],
            ],
            useCommandShortcut: !readOnly,
            events: {
                change: () => {
                    if (!readOnly && onChange) {
                        const markdown = editorInstanceRef.current.getMarkdown();
                        onChange(markdown);
                    }
                },
            },
        });

        if (readOnly) {
            disableEditor();
        }

        return () => {
            editorInstanceRef.current.destroy();
        };
    }, [height, onChange, readOnly]);

    useEffect(() => {
        if (editorInstanceRef.current && editorInstanceRef.current.getMarkdown() !== initialValue) {
            editorInstanceRef.current.setMarkdown(initialValue);
        }
    }, [initialValue]);

    const disableEditor = () => {
        const editor = editorInstanceRef.current;
        editor.getEditorElements().mdEditor.contentEditable = false;
        editor.getEditorElements().wwEditor.contentEditable = false;
    };

    const insertImage = (imageUrl) => {
        if (editorInstanceRef.current) {
            editorInstanceRef.current.insertText(`![이미지 설명](${imageUrl})`);
        }
    };

    useImperativeHandle(ref, () => ({
        getInstance: () => editorInstanceRef.current,
        insertImage, 
    }));

    return (
        <div
            className="form-conts"
            style={{
                width: '100%',
            }}
        >
            <div ref={editorRef}></div>
        </div>
    );
});

export default TextEditor;
